import { render, staticRenderFns } from "./WysiwygTextarea.vue?vue&type=template&id=386c9c7e&scoped=true&"
import script from "./WysiwygTextarea.vue?vue&type=script&lang=ts&"
export * from "./WysiwygTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./WysiwygTextarea.vue?vue&type=style&index=0&id=386c9c7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386c9c7e",
  null
  
)

export default component.exports